var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tippy',{staticClass:"mx-0.5 self-center",attrs:{"content":"Informations complètes","placement":"bottom-end"}},[_c('base-icon',{staticClass:"text-green-500",attrs:{"icon":"check","size":"sm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }